import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

export function getClientDashboard() {
  return clientPortalRequest("/dashboard");
}

export function getClientPortalDashboard(params = {}) {
  return clientPortalRequest(`/portal-dashboard${buildClientQuery(params)}`);
}

export function listClientPortalViews(query = "") {
  const path = query.startsWith("?") ? `/views${query}` : "/views";
  return clientPortalRequest(path);
}

export function getClientPortalView(clientViewId) {
  return clientPortalRequest(`/views/${clientViewId}`);
}

export function getClientPortalViewDashboard(clientViewId) {
  return clientPortalRequest(`/views/${clientViewId}/dashboard`);
}
